import React, {Component} from 'react';
import Teaser from './Shared/Teaser';
import BottonPushes from './Shared/BottonPushes';
import Breadcrumbs from "./Header/Breadcrumbs";

class SalonTherapiesPage extends Component {
    isBreadcrumb = () => {
        const isBreadcrumb = this.props.breadcrumbs.Breadcrumb;
        if (isBreadcrumb) {
            return isBreadcrumb;
        }
        else {
            return "";
        }
    };

    render() {
        const buttonPusheClass = ["push-consultation-tool", "push-healthy-scalp"];
        return (
            <div>
                {<Breadcrumbs breadcrumbProps={this.isBreadcrumb()}/>}
                <div className="main">
                    <section className="main-header">
                        <h1 dangerouslySetInnerHTML={{"__html": this.props.salonTherapies.Model.Title.Value}}></h1>
                        <p className="big-text"
                           dangerouslySetInnerHTML={{"__html": this.props.salonTherapies.Model.Subtitle.Value}}></p>
                    </section>
                    <Teaser teaser={this.props.salonTherapies.Model.Teasers} teaserClass={"success-stories"}/>
                    {this.props.salonTherapies.Model.ButtonUrl && this.props.salonTherapies.Model.ButtonUrl.Value !== "" ? (
                        <div className="center-content">
                            <a href={this.props.salonTherapies.Model.ButtonUrl.Value}
                               className="button inverse">{this.props.salonTherapies.Model.ButtonText.Value}</a>
                        </div>
                    ) : null}
                    {<BottonPushes
                        bottonPushes={this.props.salonTherapies.Model.BottomTiles}
                        salonCountries={this.props.salonCountries}
                        salonFinder={this.props.salonTherapies.Model}
                        countryCode={this.props.lang}
                        buttonPusheClass={buttonPusheClass}
                    />}
                </div>
            </div>
        )
    }
}

export default SalonTherapiesPage;
